import React from 'react';
import * as PropTypes from 'prop-types';
import useCalendarStyles from '../availabilities/hooks/useCalendarStyles';
import SideHours from './SideHours';
import Day from './Day';

function Week(props) {
  const { displaySideHours, displayHourCase, daysOfWeek, sideHours, onWeekDayClick, children, onCalendarCaseClick, highlightToday } = props;
  const { classes } = useCalendarStyles();

  return (
    <div className={classes.calendarBox}>
      {displaySideHours && <SideHours hours={sideHours} />}
      <div className="weekbox" style={{ gap: 5 }}>
        {daysOfWeek.map((day) => (
          <Day
            key={day.date}
            day={day}
            onWeekDayClick={onWeekDayClick}
            displaySideHours={displaySideHours}
            displayHourCase={displayHourCase}
            onCalendarCaseClick={onCalendarCaseClick}
            highlightToday={highlightToday}
          >
            {(hour) => children(hour)}
          </Day>
        ))}
      </div>
    </div>
  );
}

Week.defaultProps = {
  onWeekDayClick: null,
  onCalendarCaseClick: null,
  displayHourCase: true,
  displaySideHours: true,
  highlightToday: false,
};

Week.propTypes = {
  displayHourCase: PropTypes.bool,
  displaySideHours: PropTypes.bool,
  highlightToday: PropTypes.bool,
  onWeekDayClick: PropTypes.func,
  onCalendarCaseClick: PropTypes.func,
  daysOfWeek: PropTypes.arrayOf(PropTypes.object).isRequired,
  sideHours: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.func.isRequired,
};

export default Week;
